
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { userSelector } from "slices/userSlice";
import { usePermissions } from "layouts/Admin";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { paymentSelector } from "slices/paymentSlice";
import ConfirmationStatus from "components/common/ConfirmationMessageStatus";
import { handleMultipleStatus } from "slices/paymentSlice";
import { fetchInterpreterInvoices , downloadInterpreterInvoice } from "slices/interpreterInvoiceSlice";
import PaymentSideModal from "components/payments/PaymentSideModal";
import { Button } from "@mui/material";
import { setInterpreterPayments, downloadFullPaymentReport } from "slices/paymentSlice";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import { Link } from "react-router-dom";
import { setActionAssign } from "slices/actionButtonSlice";
import { fetchAppointmentView } from "slices/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import Swal from "sweetalert2";
const apiService = new Api();

function Invoices() {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { generatedInvoices } = useSelector(paymentSelector);

    const [payment, setPayment] = useState([])
    const [totalPages, settotalPages] = useState(0)
    const [loader, setloader] = useState(false)
    const [loading, setLoading] = useState(false)
    const [current_page, setcurrentPage] = useState(1)
    const [pageLength, setpageLength] = useState(10)
    const [total, settotal] = useState(10)
    const [statusModal, setStatusModal] = React.useState(false);
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [paymentDetail, setPaymentDetail] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const { user } = useSelector(userSelector);
    const userToken = user.token;
    const [item, setItem] = React.useState({});
    const [filterDates, setFilterDates] = React.useState({
        start_date: "",
        end_date: "",
    });



    // No initial API call; data will be fetched only when a filter/search is performed.

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false);
            setloader(true);
            dispatch(fetchInterpreterInvoices("", "", "", "", (res) => {
                setPayment(res.data);
                settotalPages(res.last_page);
                setcurrentPage(res.current_page);
                setpageLength(res.per_page);
                settotal(res.total);
                setInterpreterPayments(res.data);
                setloader(false);
            }))
            hideConfirmStatusDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    useEffect(() => {
        setloader(true);
        dispatch(fetchInterpreterInvoices(1, {}, false, false, (res) => {
            setPayment(res.data);
            settotalPages(res.last_page);
            setcurrentPage(res.current_page);
            setpageLength(res.per_page);
            settotal(res.total);
            dispatch(setInterpreterPayments(res.data)); // important: dispatch here
            setloader(false);
        }));
    }, [dispatch]);



        const fetchInterpreterPaymentsWrapper = (page, params = {}, disableLoader = false) => async (dispatch) => {
        const callback = (res) => {
            if (res) {
                setPayment(res.data);
                settotalPages(res.last_page);
                setcurrentPage(res.current_page);
                setpageLength(res.per_page);
                settotal(res.total);
                setInterpreterPayments(res.data);
                setloader(false);
            }
        };
    
        const payload = {
            ...params,
            pageLength: Number(params.pageLength || pageLength),
            page: page || current_page
        };
    
        return dispatch(fetchInterpreterInvoices (page || current_page, payload, disableLoader, false, callback));
    };



    const hideConfirmStatusDialog = () => {
        setStatusModal(false);
    }
    const showConfirmStatusDialog = () => {
        setStatusModal(true);
        return
    };
    const handleStatusChangeItems = () => {
        dispatch(handleMultipleStatus({ ids: selectedItems }, submitCallback))
    }

    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(payment?.map((val) => val.id.toString()))
    }

    // Filter/search handlers for InvoicePayments
    // const handleFilter = (data) => {
    //     setloader(true);
    //     dispatch(fetchInterpreterInvoices(1, data, false, false, (res) => {
    //         setPayment(res.data);
    //         settotalPages(res.last_page);
    //         setcurrentPage(res.current_page);
    //         setpageLength(res.per_page);
    //         settotal(res.total);
    //         setInterpreterPayments(res.data);
    //         setloader(false);
    //     }));
    // };
    const handleFilter = (filters) => {
  setloader(true);

  const params = {
    start_date: filters.start_date || "",
    end_date: filters.end_date || "",
    search: filters.search || searchTerm || "",
  };

  dispatch(fetchInterpreterInvoices(1, params, false, false, (res) => {
    setPayment(res.data);
    settotalPages(res.last_page);
    setcurrentPage(res.current_page);
    setpageLength(res.per_page);
    settotal(res.total);
    dispatch(setInterpreterPayments(res.data)); // dispatch inside
    setloader(false);
  }));
    };
    useEffect(() => {
  if (searchTerm.length > 2 || searchTerm === "") {
    handleFilter({ search: searchTerm });
  }
}, [searchTerm]);

    const handleReset = (defaultValues) => {
        setloader(true);
        dispatch(fetchInterpreterInvoices(1, defaultValues, false, false, (res) => {
            setPayment(res.data);
            settotalPages(res.last_page);
            setcurrentPage(res.current_page);
            setpageLength(res.per_page);
            settotal(res.total);
            setInterpreterPayments(res.data);
            setloader(false);
        }));
    };

    // ...existing code...
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchInterpreterInvoices("", "", "", "", (res) => {
                setPayment(res.data);
                settotalPages(res.last_page);
                setcurrentPage(res.current_page);
                setpageLength(res.per_page);
                settotal(res.total);
                setInterpreterPayments(res.data);
                setloader(false);
            }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        {(checkPermission("Change Interpreter Status") && payment?.find(i => i.status === "pending")) &&
                            <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                        }
                    </div>
                </th>
                <th>
                    <TableHeaderItem
                        title="Invoice"
                        sortBy="id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                {/* <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="appt_no"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Hours"
                        sortBy="payment"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Hourly Rate"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Weekend/Holiday"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Travel Fee"
                        sortBy="travel_fee"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th> */}
                <th>
                    <TableHeaderItem
                        title="Total"
                        sortBy="total_amount"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                {/* <th>
                    <TableHeaderItem
                        title="status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th> */}

                <th>
                    <TableHeaderItem
                        title="Created At"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Action"
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, current_page, selectedItems]);

    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    // ...existing code...
    const renderTableContent = React.useCallback(() => {
        return (
            <>

                {
                }
                {payment?.map((item, index) => (
                    <PaymentItems item={item} setItem={setItem} invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} setPaymentDetail={setPaymentDetail}  handleChange={handleChange} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
                ))}
            </>
        )
    }, [payment, selectedItems]);


    const callViewApi = async () => {
        handleFilter(filterDates);
        
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true);
        console.log("data", data)
        const submitCallback = (success, message) => {
            callBack && callBack();
            if (success) {
                handleCloseCheckinCheckoutModal();
                callViewApi();
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false);
                // scheduleDetailModal?.show && openModal()
            } else {
                toast.error(message, {
                    className: "errorToast",
                });
                setLoading(false);
            }
        };
        dispatch(setActionAssign(data.id, data, end_point, submitCallback));
    };
    // ...existing code...
    return (
        <>

            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
            {/* <InvoicePayments onFilter={handleFilter} onReset={handleReset} setFilterDates={setFilterDates}/> */}
            <div className="content">
                <div class="row_main_head"><h2 class="main_heading">Invoices</h2></div>
            <ListLayout
                time={false}
                addButtonDisabled={true}
                // buttonTitle='downlaod all record'
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                hideRemoveButton={true}
                paymentButton={true}
                totalPages={totalPages}
                fetchList={fetchInterpreterPaymentsWrapper}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showConfirmDialog={showConfirmStatusDialog}
                loader={loader}
                noOfItems={total}
                containerStyle={{ marginTop: '0' }}
                searchPlaceholder="Search..."
            >
                {statusModal && <ConfirmationStatus onClose={hideConfirmStatusDialog} isOpen={statusModal} onConfirm={handleStatusChangeItems} />}
            </ListLayout>
            </div>

            <PaymentSideModal data={paymentDetail} />

        </>

    )
}


const PaymentItems = ({
    data, index, current_page, pageLength, handleChange, setPaymentDetail, selectedItems, checkPermission, setItem, item
}) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const dispatch = useDispatch();
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    const [downloading, setDownloading] = React.useState(false);

    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };

    const handleOpenCheckinCheckoutModal = (itemData) => {
        // console.log('shery', itemData);
        setCheckinCheckoutModal(true);
        setItem({ id: itemData?.id , details: itemData , travel_fee: itemData?.appointment_details?.travel_fee_amount , travel_approved : itemData?.appointment_details?.travel_approved , adjust_modal : true });
    };

    // const handleDownloadInvoice = () => {
    //     if (!data?.appointment?.id) return toast.error("Invalid appointment ID");
    //     dispatch(downloadInterpreterInvoice(data?.appointment?.id));
    // };
    const handleDownloadInvoice = async () => {
    if (!data?.id) return console.log("Invalid job ID");

    try {
      setDownloading(true); // show loading
      const result = await dispatch(downloadInterpreterInvoice(data?.id));
      if (result?.error) {
        console.log("Failed to download invoice.");
      }
    } catch (err) {
      console.log("Something went wrong while downloading.");
    } finally {
      setDownloading(false); // hide loading
    }
  };






    return (
        <>
            <tr>
                <td style={getBackgroundStyle(data?.status)}>
                    <div className="row_check">
                        <span>{serial}</span>
                        {/* {(checkPermission("Change Interpreter Status") && data?.status === "pending") &&
                        <label className="custom-checkbox checkbox">
                            <input type="checkbox" name="select-all" data-value={data.id} checked={selectedItems.includes(data.id.toString())} onChange={handleChange} />
                            <span className="checkmark"></span>
                        </label>
                    } */}
                    </div>
                </td>

                {/* <td style={getBackgroundStyle(data?.status)}>
                    <Link
                        className="link_preview"
                        target="_blank"
                        to={`/interpreter/appointments/view/${data?.appointment?.id}`}
                    >
                        {data?.appointment?.appid}
                    </Link>
                </td> */}
                <td style={getBackgroundStyle(data?.status)}>
                    {data?.invoice_number || ''}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    {data?.total_amount || ''}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    {/* {data?.created_at || ''} */}
                      {data?.created_at ? moment.utc(data.created_at).local().format('YYYY-MM-DD hh:mm A') : ''}
                </td>
                {/* <td style={getBackgroundStyle(data?.status)}>
                    ${data?.appointment?.interpreter_payment?.weekend_holiday}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.appointment?.interpreter_payment?.travel_fee}
                </td>
                <td style={getBackgroundStyle(data?.status)}>
                    ${data?.appointment?.interpreter_payment?.total_amount}
                </td>
                <td style={getBackgroundStyle(data?.status)} className="text-capitalize">
                    {data?.appointment?.status || 'N/A'}
                </td>
                <td style={getBackgroundStyle(data?.status)} className="text-capitalize">
                    {data?.appointment?.date || 'N/A'}
                </td> */}
                <td style={getBackgroundStyle(data?.status)}>
                    <button
                        type="button"
                        className="main_button"
                        onClick={handleDownloadInvoice}
                        disabled={downloading}
                        style={{ minWidth: 100 }}
                    >
                        {downloading ? "Downloading..." : "Download"}
                    </button>
                </td>
            </tr>
        </>
    )
}


export default Invoices;